import httpClient from '@/http-client'

export const getListSerial = (Options = {}) => {
  return httpClient
    .get('/api/v1/product-costs/serials', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getListSparePart = (Options = {}) => {
  return httpClient
    .get('/api/v1/product-costs/spare-parts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formModel = (Options = {}) => {
  return httpClient
    .get('/api/v1/product-costs/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const serialToExcel = data => {
  return httpClient
    .post('/api/v1/product-costs/serials', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const sparePartToExcel = data => {
  return httpClient
    .post('/api/v1/product-costs/spare-parts', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  getListSerial,
  getListSparePart,
  formModel,
  serialToExcel,
  sparePartToExcel
}
